export default __webpack_public_path__ + "static/media/pumapay-business-console.32949a96.png";